// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Vendor
import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
import { List, ListItem } from 'material-ui/List';
import SwipeableViews from 'react-swipeable-views';
import Avatar from 'material-ui/Avatar';
const moment = require('moment-timezone');
import { withRouter } from 'react-router-dom';

// Components
import ServiceListItems from 'components/ServiceListItems';
import ClientListItems from 'components/ClientListItems';
import ModulesContainerDesktop from 'components/ModulesContainerDesktop';
import InteractionPanel from 'components/InteractionComponents/InteractionPanel';
import { FluidSection } from 'components';
import ContextualBarSC from '../../components/InteractionComponents/ContextualBarSC';
import TextButton from '../../components/Button/TextButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ServiceDashboard from './ServiceDashboard';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import H3 from 'components/Primatives/H3';
import PText from 'components/Primatives/PText';

// Utils
import { getServicePeriod } from 'utils/database/database-utils';
import getAvatar, { getInitialsString } from 'utils/avatarUtils';
import { constants } from 'constants/index';
import { toArray } from 'utils/lodashUtils';


class ProServiceModules extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      viewIndex: 0,
      clients: null,
      selectedService: null,
      selectedClient: null,
      width: 0,
      height: 0,
      provider: null,
      service: null,
      company: null,
    }
  }

  // LIFECYCLE HOOKS
  componentDidMount() {
    this.props.resetUnreadCounts();
    this.props.getDBServices();
    this.props.getDBProviders();
    this.props.getDBClients();

    document.getElementById('top').scrollIntoView();
    if (this.props.userData && this.props.userData.provider){
      this.props.filterClientProfileByActivityStatus(this.props.userData);
    }
    // this.props.getDBProviders();
    // this.props.getDBServices();
    this.props.getDBProviderCompanies();
    this.props.getDBServiceCategories();
    this.props.getDBServiceModules();
    // this.props.updateLocation(this.props.location.pathname)

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if (!this.props.userId && !this.props.loginDialogOpen) {
      setTimeout(()=>{
          if (!this.props.userId && !this.props.userData && !this.props.loginDialogOpen) this.props.openLoginDialog();
      }, 2500);
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.userId) {
      // if (this.props.reduxLocation !== nextProps.reduxLocation) {
      //     console.log('LOCATION HAS CHANGED - UPDATING GLOBAL LOCATION STATE');
      //     this.props.updateLocation(nextProps.location.pathname)
      // }
    }
  }

  componentWillMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  

  componentDidUpdate(prevProps, prevState) {
    if (prevState.width !== this.state.width) {
      if (this.state.viewIndex !== 3) {
        if ((this.state.width < constants.layout.breakpoint.break1) && this.state.selectedService) {
          this.setState({viewIndex: 3});
        }
      } else if (this.state.viewIndex === 3) {
        if ((this.state.width > constants.layout.breakpoint.break1) && this.state.selectedService) {
          this.setState({viewIndex: 2});
        }
        if (!this.state.selectedService) {
          this.setState({viewIndex: 1});
        }
      }
    }
    if ((!prevState.service || !prevState.provider || !prevState.company) && prevState.selectedService) {
      this.getProviderCompanyService(this.props, this.state.selectedService);
    }
    if (prevProps.userId) {
      if (!isEqual(prevProps.userId.clients, this.props.userId.clients)){
        this.props.filterClientProfileByActivityStatus(this.props.userData);
      }
    }
    if (this.state.selectedService && (prevState.selectedService !== this.state.selectedService)) {
        this.props.loadUpcomingDbBookings({
          userId: this.props.userData.uid,
          serviceId: this.state.selectedService._id,
          clientUid: this.state.selectedClient.uid,
          userType: 'provider'
      })
    }
    // if (!isEqual(prevState.selectedService, this.state.selectedService) && this.state.selectedService !== null && this.state.selectedClient !== null) {
    //   console.log('GETTING THREAD');
    //   // this.props.getMessageThread(this.props.userData, this.state.selectedService, ()=>{}, 'provider', this.state.selectedClient);
    // }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    this.props.updateWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
  }

  // HELPER FUNCTIONS

  handleServiceSelect = (service) => {
    const viewIndexMobile = (this.state.width  && this.state.width < constants.layout.breakpoint.break1) ? 3 : 2;
    this.props.setSelectedService(service);
    this.setState(() => ({
      selectedService: service,
      viewIndex: viewIndexMobile,
    }));

    this.props.clearBookings();
    this.props.loadUpcomingDbBookings({
        userId: this.props.userData.uid,
        serviceId: service._id,
        clientUid: this.state.selectedClient.uid,
        userType: 'provider'
    })  
    
    console.log('GETTING THREAD AT PRO SERVICE SELECT');
    this.props.getMessageThread(this.props.userData, service, ()=>{
      console.log('GOT MESSAGE THREAD AT PRO SERVICE SELECT');
    }, 'provider', this.state.selectedClient);
  }

  handleChangeViewIndex = (state) => {
    this.setState({
      viewIndex: state
    });
  }

  handleBackToServiceList = () => {
    this.setState({
      viewIndex: 1,
    }, () => {
      this.setState({selectedService: null})
      }
    );
  }
  
  handleClientSelect = (client, i) => {
    this.setState({
      selectedClient: client,
      viewIndex: 1,
      clientIndex: i
    });
    this.props.setSelectedClient(client);
  }
  
  getProviderCompanyService = (props, selectedService) => {
    const { companies, dbProviders, services, match } = props;

    if (dbProviders && services && companies) {
        // console.log(`%cdbPROVIDERS OBJECT SHOULD BE ARRAY${JSON.stringify(props.dbProviders)}`,'color: greenyellow');
        return dbProviders.map((provider)=> {
            // console.log(`%c${JSON.stringify(provider.uid)} ${JSON.stringify(props.match.params.id)}`,'color: deeppink');
            return services.map(service => {
                if (selectedService && service._id === selectedService._id) {
                    
                    return companies.map(company => {
                        if (company._id === service.company) {            
                            if (provider.uid === service.provider) {
                                // console.log('MATCH FOUND FOR PROVIDER', provider.uid, service.provider);
                                // console.log(provider, company, service, 'PROCOMSER PRESENT?');
                                this.setState({
                                    provider,
                                    service,
                                    company
                                });
                            }
                        }
                    })
                }
            })
        });
    } else {
        return null;
    }
  }

  resetService = () => {
    this.props.resetUnreadCounts();
    this.handleChangeViewIndex(1);
    this.setState(() => ({
      selectedService: null
    }), () => {
      this.props.forgetCurrentThread();
    });
  }

  resetClient = () => {
     this.props.resetUnreadCounts();
     this.handleChangeViewIndex(0);
     this.setState(() => ({
       selectedClient: null,
       selectedService: null
     }), () => {
       this.props.forgetCurrentThread();
     });
  }

  getClientsProviderServices() {
    let providerServices = [];
    this.props.allServices.map(service => {
      // console.log('SERVICE', service);
      // console.log('CLIENT', this.props.userData);
      if (service.provider === this.props.userData.uid) {
        // console.log('MATCH:',  service.provider);
        let servicesClients = map(service.clients, client => client);
        console.log('SERVICE`S CLIENTS',  servicesClients);
        
        servicesClients.map(client => {
          // console.log('CLIENT OF SERVICE', client._id, this.state.selectedClient.uid);
          
          if (client._id === this.state.selectedClient.uid) {
            return providerServices.push(service);
          }
        });
      }
    });
    
    return providerServices;
  }

  // RENDER

  render = () => {
    // console.log('ProSM-STATE', this.state);
    // console.log('ProSM-PROPS', this.props);
    const { userData } = this.props;
    const {
      viewIndex,
      selectedClient,
      selectedService,
      clientIndex,
      service,
      provider,
      company
    } = this.state;

    const {
      pendingClients,
      activeClients,
      inactiveClients,
    } = this.props.filteredClients;
    
    let activePeriods = [];
    if (userData && userData.clients && userData.clients.length > 0 && selectedService && selectedClient) {
      activePeriods = userData.clients.map(client => {
        if (client.uid === selectedClient.uid) {
          let serviceActivePeriodList = client.services.map(serviceItem => { // variable name 'service' is already used in destructured state declarations
            if (serviceItem._id === selectedService._id) {
              return serviceItem.activePeriods;
            }
          })
          serviceActivePeriodList = serviceActivePeriodList.filter(activePeriodList => activePeriodList);
          // console.log('activePeriods-service',service[0])
          return serviceActivePeriodList[0];
        }
      })
      activePeriods = activePeriods.filter(activePeriod => activePeriod);
      activePeriods = activePeriods[0];
    }
    // console.log('activePeriods', activePeriods)
    if (this.props.loginDialogOpen && this.props.userId) this.props.closeLoginDialog();

    if ( this.props.userId && (this.props.emailIsVerified || this.props.emailVerified)) {
      // console.log('ServiceDashboard-this.state.viewIndex',  this.state.viewIndex)
      // console.log('ServiceDashboard-this.state.selectedService',  this.state.selectedService)
      return (
        <React.Fragment>
          { !(this.state.width < constants.layout.breakpoint.break1 && this.state.viewIndex === 2) &&
            <SwipeableViews
              index={viewIndex}
              onChangeIndex={this.handleChangeViewIndex}
              className="ProServiceModulesOuterDiv"
              style={{
                alignItems: 'center',
                maxWidth: 1200,
                alignSelf: 'center',
                justifySelf: 'stretch',
                flex: 1,
                width: '100vw'
              }}
            >
              { viewIndex === 0 && 
                <FlexColumn data-testid="client-list" style={{ paddingLeft: 30, fontSize: constants.text.baseFontStyles.fontSize, backgroundColor: constants.color.grey5, minHeight:'calc(100vh - 73px)'}}>
                  {/* <div style={{ width: '100%' }}> */}
                    
                    { (!activeClients || activeClients && activeClients.length === 0 ) && (!pendingClients || pendingClients && pendingClients.length === 0)  && (!inactiveClients || inactiveClients && inactiveClients.length === 0)  &&
                      <p style={{ alignSelf: 'center', marginTop: 200 }}>This provider account has no clients at this time.</p>
                    }
                    
                    { (activeClients && activeClients.length > 0 ) || (pendingClients && pendingClients.length > 0)  && (inactiveClients && inactiveClients.length > 0)  &&
                      <p>Select a client to interact with them.</p>
                    }
                    
                    <List style={{ width: '100%' }}>
                      { activeClients && activeClients.length > 0 &&
                        <ClientListItems
                          styles={styles.container}
                          clients={activeClients}
                          onClientSelect={this.handleClientSelect}
                          header={"Current Clients"}
                        />
                      }
                      { pendingClients && pendingClients.length > 0 &&
                        <ClientListItems
                          styles={styles.container}
                          clients={pendingClients}
                          onClientSelect={this.handleClientSelect}
                          header={"Upcoming Clients"}
                        />
                      }
                      { inactiveClients && inactiveClients.length > 0 &&
                        <ClientListItems
                          styles={styles.container}
                          clients={inactiveClients}
                          onClientSelect={this.handleClientSelect}
                          header={"Previous Clients"}
                        />
                      }
                    </List> 
                  {/* </div> */}
                </FlexColumn>
              }
              {   viewIndex === 1 && selectedClient &&
                  <div style={{...styles.pageSectionStyles, width: '100vw', flexFlow: 'column nowrap', flex: 1, minHeight: 'calc(100vh - 73px)' }}>
                    <ContextualBarSC>
                      <TextButton
                          onClick={this.resetClient}
                          style= {{ width: 48 }}
                      >
                          <ArrowBack />
                      </TextButton>
                      <ListItem
                          key={selectedClient.uid}
                          leftAvatar={
                            <Avatar
                              color={(clientIndex % 2 === 0) ? `white` : `rgba(0,0,0,0.5)`}
                              backgroundColor={(clientIndex % 2 === 0) ? `${constants.color.primary}` : `${constants.color.secondary}`}
                              src={(selectedClient.profilePhotoURL) ? selectedClient.profilePhotoURL : null }
                            >
                              { selectedClient && !selectedClient.profilePhotoURL &&
                                  <div style={{ position: 'relative', top: 2 }}>
                                      {getInitialsString(selectedClient.firstName, selectedClient.lastName)}
                                  </div>
                              }
                            </Avatar>
                          }
                          primaryText={`${selectedClient.firstName} ${selectedClient.lastName}'s Services with You`}
                          secondaryText={'Select the service your interaction will involve.'}
                          style={{ width: '100%', textOverflow: 'ellipsis', backgroundColor: 'rgba(255, 255, 255, 0)' }} //backgroundColor: 'rgba(0, 0, 0, 0.87)', show this bg condishaly if list item is selected
                          nestedListStyle={{ marginRight: 30, marginLeft: 30 }}
                          hoverColor='none'
                          disableTouchRipple
                      />
                    </ContextualBarSC>
                    <List style={{ paddingLeft: 30, backgroundColor: constants.color.grey5 , display: 'flex', flex: 1}}>
                      { !selectedService &&
                        <ServiceListItems
                          styles={ styles.container }
                          providers={ this.props.providers }
                          services={ this.getClientsProviderServices() }
                          selectedClient={ this.state.selectedClient }
                          onServiceSelect={ this.handleServiceSelect }
                          showServicePhoto
                        />
                      }
                    </List>
                  </div>
              }
              {   viewIndex === 2 && selectedClient &&
                <div style={{...styles.pageSectionStyles, width: 'auto', flex: 1 }}>
                  <FlexColumn
                    style={{maxHeight: 'calc(100vh - 73px)', overflow: 'scroll'}}
                  >
                    <ContextualBarSC
                      style={{alignSelf: 'stretch', backgroundColor: constants.color.grey5}}
                    >
                      <TextButton
                        onClick={this.resetService}
                        style= {{ width: 48 }}
                      >
                          <ArrowBack />
                      </TextButton>
                      <PText>Back to Client Services</PText>
                    </ContextualBarSC>
                    <ServiceDashboard 
                      service={ selectedService }
                      activePeriods={ activePeriods }
                      provider={ this.props.userData }
                      userData={ this.props.userData }
                      reduxLocation={ this.props.reduxLocation }
                      style={{maxHeight: 'auto',  minHeight: 'auto', overflow: 'scroll'}}
                    />  
                  </FlexColumn>
                <InteractionPanel
                    selectedClient={ selectedClient }
                    clientIndex={ clientIndex }
                    selectedService={ selectedService }
                    location={ this.props.reduxLocation }
                    channel={ this.props.channel }
                    service={ service }
                    company={ company }
                    provider={ provider }
                    shouldHideBookingTab
                    style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 'calc(100vh - 73px)', maxHeight: 'calc(100vh - 73px)' }}
                  />
                </div>
              }
            </SwipeableViews>
          }
          { viewIndex === 3 &&
            <InteractionPanel
              selectedClient={ selectedClient }
              clientIndex={ clientIndex }
              selectedService={ selectedService }
              location={ this.props.reduxLocation }
              onReturnClick={ this.handleBackToServiceList }
              service={ service }
              company={ company }
              provider={ provider }
              channel={ this.props.channel }
              style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 'calc(100vh - 73px)', maxHeight: 'calc(100vh - 73px)' }}
            />
          }
        </React.Fragment>
      );
    }
    // SHOW NOTHING WHILE LOADING PROPS
    return null;
  }
}

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    backgroundColor: '#fff',
    marginTop: 0,
    padding: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0
  },
  OuterContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minWidth: constants.layout.ListPanel.minWidth,
    borderLeft: '1px solid rgba(0,0,0,0.14)',
    borderRight: '1px solid rgba(0,0,0,0.14)',
  },
  pageSectionStyles: {
    ...constants.layout.contentWidth,
    display: 'flex',
    flex: 1,
    flexFlow: 'row nowrap',
    alignItems: 'stretch',
    alignSelf: 'center'
},
};

const mapStateToProps = ({ client, service, provider, chat, router, company, auth }) => {
  return {
    // AUTH STATE
    loginDialogOpen: auth.loginDialogOpen,
    emailIsVerified: auth.verificationStatus,
    emailVerified: auth.authData.emailVerified,
    userData: client.clientData,
    userId: auth.authData && auth.authData.id,

    // OTHERS
    channel: chat.messageThread,
    
    providers: provider.providers,
    dbProviders: provider.providers,
    
    reduxLocation: router.location,
    
    allServices: toArray(service.services) || ['',''],
    services: service.services,
    serviceCategories: service.categories,
    serviceModules: service.modules,
    companies: company.providerCompanies,
    // sbmProvider: booking.provider
    filteredClients: {
      activeClients: provider.activeClients,
      pendingClients: provider.pendingClients,
      inactiveClients: provider.inactiveClients,
    }
  };
}

export default withRouter(connect(mapStateToProps, actions)(ProServiceModules));


// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ProServiceModules.jsx